import {
  ISearchGoodReceiveReq,
  ISearchGoodReceiveRes,
} from '@/interfaces/goodReceive';
import * as baseAdapter from './baseAdapter';

export const searchGoodReceives = async (req: ISearchGoodReceiveReq) => {
  const ret = await baseAdapter.post<ISearchGoodReceiveRes>(
    '/goodReceive/gets',
    req,
  );
  return ret;
};

export const confirmGoodRecieve = async (id: number) => {
  const ret = await baseAdapter.put(`/goodReceive/update/${id}`, { id });
  return ret;
};
